import Layout2 from '@/layout/Layout2'
import { RouterTabRoutes } from 'vue-router-tab'

export default [{
  path: '/Center',
  component: Layout2,
  children: [
    ...RouterTabRoutes,
    {
      path: 'Index',
      meta: { title: '系统首页' },
      component: () => import('@/components/Center/Index')
    },
    {
      path: 'Version',
      meta: { title: '版本更新日志' },
      component: () => import('@/components/Center/Version')
    },
    {
      path: 'EditPassword',
      meta: { title: '修改密码' },
      component: () => import('@/components/Center/EditPassword')
    },
    {
      path: 'Loading',
      component: () => import('@/components/Center/Loading')
    }]
}]
